<template>
<v-dialog
    v-model="dialog"
    fullscreen
    v-if="link != null"
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Edit Link</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickCancel"
                >
                    Cancel
                </v-btn>

                <v-btn
                    dark
                    text
                    @click="onClickSave"
                >
                    Save &amp; Close
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

             <v-select
                style="margin-top: 15px"
                label="Purpose"
                :items="$rc.enumChoices('link_purpose', false)"
                v-model="link.purpose"
            />

            <div
                v-if="link.purpose.includes('calendly')"
                style="text-align: right"
            >
                <v-btn
                    v-on:click="onClickCalendlySync"
                    style="margin-right: 15px"
                >
                    Update Calendly Event Types
                </v-btn>

                <v-btn
                    v-on:click="onClickSelectCalendlyLink"
                >
                    Select Calendly Link...
                </v-btn>
            </div>

            <v-text-field
                label="Label"
                v-model="link.label"
            />

            <v-text-field
                label="URL"
                v-model="link.url"
            />

            <div
                style="text-align: right; margin-top: 15px;"
            >
                <v-btn
                    color="primary"
                    v-on:click="onClickSave"
                >
                    Save & Close
                </v-btn>
            </div>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            last_dialog_guard: null,
            link: null,
        }
    },

    methods: {

        showDialog(link)
        {
            this.link = _.cloneDeep(link);

            this.dialog = true;
            this.last_dialog_guard = this.$router.dialog_guard;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = this.last_dialog_guard;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.closeDialog();
                return;
            }
        
            this.closeDialog();
            next(false);
        },

        onClickSave()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/links',
            
                'params' : this.link,
            
                'on_success': (data) => {
                        this.closeDialog();
                        this.$emit('update');
                    },
            
                'on_error': 'Unable to create / update link',
            });
            
        },

        onClickSelectCalendlyLink()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'LIST: /api/v1/links/calendly',
            
                'params' : {
                    },
            
                'on_success': (data) => {
                        this.selectCalendlyLink(data.results);
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        selectCalendlyLink(choices)
        {
            this.$rc.pick({
                'title': 'Choose calendly link',
                'content_before': null,
                'content_after': null,
                'choices': choices,
                'multiple': false,
                'type': 'select',
                'select_label': 'Choose Calendly Link',
                'initial_value': null,
            
                'on_ok': (value) => {
                    this.link.url = value;

                    let obj = choices.find((el) => { return el.value == value; });

                    if ( obj == null ) 
                        return;

                    if ( this.link.purpose == 'red-chirp-calendly-schedule-phone-number-plan' )
                    {
                        this.link.label = obj.numbering_plan_label;
                    }
                },
            
                'on_cancel': () => {}
            
            });
        },

        onClickCalendlySync()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/links/sync-calendly',
            
                'params' : {
                    },
            
                'on_success': (data) => {
                        this.$rc.alert("Sync started","A sync with calendly has been started.  Please give it a few minutes to complete.");
                    },
            
                'on_error': 'Unable to start calendly sync.',
            });
        },

        onClickCancel()
        {
            this.closeDialog();
        },

    },
}
</script>

<style lang="scss" scoped>
</style>